import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { CatalogPage } from './CatalogPage';
import { CatalogPageNumber } from './CatalogPageNumber';
import { CatalogOverview } from './CatalogOverview';
import get from 'lodash.get';
import { setErrorOccurred as setErrorOccurredDispatch } from '../actionCreators/uiActionCreators';
import { getCanvasDimensions, isMobilePortrait } from '../catalogHelpers';
import styles from '../styles/catalogDocument.scss';
import { DESKTOP, TABLET, MOBILE } from '../../utils/deviceType';

export const CatalogDocumentComponent = ({
    catalogPage,
    deviceType,
    margin,
    mobileScale,
    scale,
    screenOrientation,
    singlePageRatio,
    tabletScale,
    zoomedIn,
}) => {
    const singlePageDimensions = get(catalogPage, 'images.singlePageDimensions');
    const isPhonePortrait = isMobilePortrait(deviceType, screenOrientation);

    let deviceScale = scale;
    if (deviceType === TABLET) {
        deviceScale = tabletScale;
    } else if (deviceType === MOBILE) {
        deviceScale = mobileScale;
    }

    const canvasDims = getCanvasDimensions(
        singlePageDimensions,
        deviceScale,
        margin,
        deviceType,
        screenOrientation,
        singlePageRatio
    );
    const canvasHeight = get(canvasDims, 'height') || 0;
    const canvasWidth = get(canvasDims, 'width') || 0;

    const catalogPageElement = <CatalogPage catalogPage={catalogPage} deviceType={deviceType} />;
    const catalogOverviewElement = (
        <CatalogOverview catalogPage={catalogPage} deviceType={deviceType} />
    );

    return (
        <div
            className={styles.pdfDocumentWrapper}
            style={{
                height: canvasHeight ? `${canvasHeight}px` : 'auto',
                padding: zoomedIn ? '0' : margin + 'px 0',
                cursor: zoomedIn ? 'move' : 'initial',
                width: canvasWidth ? `${canvasWidth}px` : 'auto',
            }}
        >
            {catalogPageElement}
            {catalogOverviewElement}
            {!isPhonePortrait && (
                <CatalogPageNumber catalogPage={catalogPage} deviceType={deviceType} />
            )}
        </div>
    );
};

CatalogDocumentComponent.propTypes = {
    catalogPage: PropTypes.object,
    deviceType: PropTypes.string,
    margin: PropTypes.number,
    mobileScale: PropTypes.number,
    scale: PropTypes.number,
    screenOrientation: PropTypes.string,
    setErrorOccurred: PropTypes.func,
    singlePageRatio: PropTypes.number,
    tabletScale: PropTypes.number,
    zoomedIn: PropTypes.bool,
};

CatalogDocumentComponent.defaultProps = {
    deviceType: DESKTOP,
};

const mapStateToProps = state => {
    return {
        margin: state.ui.margin,
        mobileScale: state.ui.mobileScale,
        scale: state.ui.scale,
        screenOrientation: state.ui.screenOrientation,
        singlePageRatio: state.ui.singlePageRatio,
        tabletScale: state.ui.tabletScale,
        zoomedIn: state.ui.zoomedIn,
    };
};

export const mapDispatchToProps = dispatch => {
    return {
        setErrorOccurred: () => dispatch(setErrorOccurredDispatch()),
    };
};

export const CatalogDocument = createFragmentContainer(
    connect(mapStateToProps, mapDispatchToProps)(CatalogDocumentComponent),
    {
        catalogPage: graphql`
            fragment CatalogDocument_catalogPage on CatalogPage {
                file {
                    filePath
                }
                images {
                    singlePageDimensions {
                        height
                        width
                    }
                }
                ...CatalogPageNumber_catalogPage
                ...CatalogPage_catalogPage
                ...CatalogOverview_catalogPage
            }
        `,
    }
);
